<template>
  <div class="page page-with-bg page-full 404-page">
    <div class="page-header">
      <h1>404 Page Not Found</h1>
    </div>
    <p>The page is not found.</p>
  </div>
</template>

<script>
export default {
  name: "404-Not-Found"
};
</script>

<style scoped lang="scss">
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/keyboard.png');
  }
</style>